export const SERVICE_TYPE_OPTIONS = [
    { value: "MEDICAL_EQUIPMENT", label: "Matériel médical", defaultName: "Matériel médical" },
    { value: "CONTROLE", label: "Contrôle", defaultName: "Contrôle" },
    { value: "DOSSIER_LOT_PRODUCTION", label: "Dossier de lot production", defaultName: "Dossier de lot de production" },
];

const EXCLUSIVE_CONTROLE_SERVICE_TYPES = ["CONTROLE", "DOSSIER_LOT_PRODUCTION"];

export const EMPTY_SERVICE_FORM = {
    name: "Matériel médical",
    type: "MEDICAL_EQUIPMENT",
    email: "",
    mailHost: "",
    mailPassword: "",
};

export function isExclusiveControleService(type) {
    return EXCLUSIVE_CONTROLE_SERVICE_TYPES.includes(type);
}

export function availableCreateServiceTypes(services) {
    return SERVICE_TYPE_OPTIONS.filter(option => (
        !isExclusiveControleService(option.value)
        || !services.some(service => isExclusiveControleService(service.type))
    ));
}

export function serviceTypeOptionsFor(services, service) {
    return SERVICE_TYPE_OPTIONS.filter(option => (
        !isExclusiveControleService(option.value)
        || option.value === service.type
        || !services.some(item => item.id !== service.id && isExclusiveControleService(item.type))
    ));
}

export function withServiceType(form, type) {
    const defaultNames = SERVICE_TYPE_OPTIONS.map(option => option.defaultName);
    const option = SERVICE_TYPE_OPTIONS.find(item => item.value === type);
    return {
        ...form,
        type,
        name: defaultNames.includes(form.name) ? (option?.defaultName || form.name) : form.name,
    };
}

export function withValidCreateType(form, availableTypes) {
    if (availableTypes.some(option => option.value === form.type)) return form;
    return { ...form, type: "MEDICAL_EQUIPMENT", name: "Matériel médical" };
}

export function servicePatchPayload(service, patch) {
    const payload = { ...service, ...patch };
    if (!payload.mailPassword) delete payload.mailPassword;
    return payload;
}

export function serviceCountLabel(count) {
    return `${count} service${count > 1 ? "s" : ""}`;
}
